<template>
  <div>
    <PCNavbar selectIndex="12"/>
    <MobileNavBar :currentActive="11" />
    <lowCarboncategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import lowCarboncategory from '@/components/service_low_carbon_category-1'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    lowCarboncategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>